import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/mp.png'


const _withScopeId = n => (_pushScopeId("data-v-4c47fec9"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "团队动态")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 0,
  src: _imports_0,
  class: "mp",
  alt: ""
}
const _hoisted_6 = { class: "text" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_scrollbar = _resolveComponent("el-scrollbar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createVNode(_component_el_scrollbar, { class: "block-content" }, {
      default: _withCtx(() => [
        (_ctx.list.length === 0)
          ? (_openBlock(), _createBlock(_component_el_empty, {
              key: 0,
              description: "暂无动态",
              "image-size": 100
            }))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "message row",
            key: index
          }, [
            _createElementVNode("img", {
              class: "avatar",
              src: item.clientUser.avatar
            }, null, 8, _hoisted_4),
            (item.source === 'mp')
              ? (_openBlock(), _createElementBlock("img", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, _toDisplayString(item.clientUser.real_name), 1),
              _createElementVNode("div", _hoisted_8, _toDisplayString(item.content), 1)
            ]),
            _createElementVNode("div", _hoisted_9, _toDisplayString(item.create_time), 1)
          ]))
        }), 128))
      ]),
      _: 1
    })
  ]))
}